import TableFilter from '@/components/common/tablefilter/TableFilter.vue'
import { mapState } from 'vuex';

export default {
  name: 'SearchChecklist',
  components: {
    TableFilter
  },
  props: {
    value: Array,
    disabled: Boolean,
    elname: String,
    path: String,
    nameParam: String,
    keyParam: String,
    without: Boolean,
    options: Array | Object,
    btnIsVisible: {
      type: Boolean,
      default: true
    },
    applyText: String,
    filters: {
      type: Object,
      default: null
    },
    btnIcon: {
      type: String,
      default: 'list'
    },
    displayLimit: {
      type: Number,
      default: null
    },
    displaySelectedItems: {
      type: Boolean,
      default: true
    },
    colsm: {
      type: Number,
      default: 4
    },
    itemNameFunc: Function,
    groupConfigKey: {
      type: String,
      default: null
    },
    requestType: {
      type: String,
      default: 'GET'
    },
    sortByName: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      currentReq: null,
      loading: false,
      items: null,
      searchTxt: '',
      selected: {},
      page: 1,
      pageCount: 1,
      filterValues: {}
    }
  },
  computed: {
    ...mapState(['config']),
    itemKey () {
      if (this.keyParam) {
        return this.keyParam;
      }
      return 'id';
    },
    getTitle () {
      return this.$t('searchchecklist.modal-title.' + this.elname)
    },
    filteredPageItems () {
      if (this.displayLimit && this.filteredItems) {
        const recCount = this.filteredItems.length;
        this.pageCount = Math.ceil(recCount / this.displayLimit);
        if (this.pageCount < this.page) {
          this.page = this.pageCount;
        }
        if (recCount > this.displayLimit) {
          return this.filteredItems.slice((this.page - 1) * this.displayLimit, this.page * this.displayLimit);
        }
      }
      return this.filteredItems;
    },
    filteredItems () {
      if (!this.items) {
        return [];
      }
      if (this.searchTxt.length > 0) {
        const tmpStr = this.searchTxt.toLowerCase();
        if (this.groupConfigKey) {
          const els = {};
          const self = this;
          Object.keys(this.items).forEach(key => {
            els[key] = self.items[key].filter(el => el[self.nameParam].toLowerCase().indexOf(tmpStr) > -1)
          });
          return els;
        } else {
          return this.items.filter(el => el[this.nameParam].toLowerCase().indexOf(tmpStr) > -1);
        }
      }
      return this.items;
    },
    checklistGroups () {
      const groups = ['default'];
      this.filteredItems.forEach(function (el) {
        if (el.group && !groups.includes(el.group)) {
          groups.push(el.group);
        }
      });
      return groups;
    },
    hasMultipleGroups () {
      let res = false;
      if (this.items) {
        this.items.forEach(function (el) {
          if (el.group && el.group != 'default') {
            res = true;
          }
        });
      }
      return res;
    }
  },
  methods: {
    updateValue () {
      let content = [];
      const self = this;
      if (this.groupConfigKey) {
        Object.keys(this.items).forEach(key => {
          content = content.concat(self.items[key].filter(el => self.selected[el[self.itemKey]] === true));
        });
      } else {
        content = this.items.filter(el => self.selected[el[self.itemKey]] === true);
      }
      if (this.selected.EMPTY) {
        const el = {};
        el[this.itemKey] = null;
        el[this.nameParam] = this.$t('searchchecklist.without.' + this.elname);
        content.unshift(el);
      }
      this.$emit('input', content);
      this.$emit('changed', content);
    },
    getItemName (item) {
      return item[this.nameParam];
    },
    clearSearch () {
      this.searchTxt = '';
    },
    checkUncheckFiltered (val, groupId = null) {
      if (this.groupConfigKey) {
        const self = this;
        Object.keys(this.filteredItems).forEach(key => {
          if (groupId === null || groupId === key) {
            this.filteredItems[key].forEach(el => {
              self.selected[el[self.itemKey]] = val;
            })
          }
        });
      } else {
        this.filteredItems.forEach(el => {
          if (groupId) {
            if (el.group == groupId || (groupId == 'default' && !el.group)) {
              this.selected[el[this.itemKey]] = val;
            }
          } else {
            this.selected[el[this.itemKey]] = val;
          }
        });
      }
      this.$forceUpdate();
    },
    removeItem (id) {
      if (id === null) {
        this.selected.EMPTY = false;
      } else {
        this.selected[id] = false;
      }
      this.updateValue();
    },
    clearSelected () {
      this.selected = [];
      this.updateValue();
    },
    getItems () {
      const self = this;
      if (this.path) {
        if (this.currentReq) {
          this.currentReq.cancel('changed search query');
        }
        this.loading = true;
        let path = this.path;
        let reqData = {};
        if (this.requestType == this.ApiRequest.REQUEST_POST) {
          reqData = this.filterValues;
        } else if (this.filters) {
          path = this.ApiRequest.addGetParamsToPath(path, this.filterValues, true);
        }
        this.currentReq = this.ApiRequest.request(path, this.requestType, reqData, function (response) {
          if (response.data) {
            if (self.itemNameFunc) {
              for (const key in response.data) {
                response.data[key][self.nameParam] = self.itemNameFunc(response.data[key]);
              }
            }
            self.items = response.data;
            self.loading = false;
          }
        });
      } else if (this.options) {
        this.sortItems(this.options);
      }
    },
    updateItems (options) {
      this.sortItems(options);
    },
    sortItems (options) {
      if (this.sortByName && this.groupConfigKey) {
        const resItems = {};
        const self = this;
        Object.keys(options).forEach(key => {
          resItems[key] = this.BasicHelper.sortArrayByKeyValue(options[key], self.nameParam);
        });
        this.items = resItems;
      } else if (this.sortByName) {
        this.items = this.BasicHelper.sortArrayByKeyValue(options, this.nameParam);
      } else {
        this.items = options;
      }
    },
    showModal () {
      this.$refs['modal-window'].show();
    },
    applyFilters () {
      this.updateValue();
      this.close();
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    changePage (pageNr) {
      this.page = pageNr;
    }
  },
  mounted () {
    const self = this;
    if (this.value) {
      this.value.forEach(el => {
        if (this.itemKey === null) {
          self.selected.EMPTY = true;
        } else {
          self.selected[el[this.itemKey]] = true;
        }
      });
    }
    if (this.filters) {
      for (const key in this.filters) {
        this.filterValues[key] = this.filters[key].defaultValue;
      }
    }
    this.getItems();
  }
}
